import { render, staticRenderFns } from "./AddFinvoiceParserPattern.vue?vue&type=template&id=50efabe9"
import script from "./AddFinvoiceParserPattern.vue?vue&type=script&lang=ts"
export * from "./AddFinvoiceParserPattern.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports